// Types
import { MessageType } from '@/types/messageType';
import { SocialProfileType } from '@/types/socialProfileType';
import { UserType } from '@/types/userType';

// Components
import Comment from '@/components/base/Comment';

export interface ReplyCommentProps {
    comment: MessageType;
    reply: MessageType;
    activeFormReply: {
        currentComment: MessageType;
        currentCommentId: string;
        parent: MessageType;
    } | null;
    markAsRead: (commentId: string, mediaId: string) => Promise<{ success: boolean }>;
    socialProfile: SocialProfileType;
    user: UserType;
    variant: 'default' | 'socialInbox';
    setReplyToAdd: (args: { commentId: string; reply: MessageType }) => void;
    setActiveFormReply: (args: {
        currentComment: MessageType;
        currentCommentId: string;
        parent: MessageType;
    }) => void;
    setDeleteReplyState: (args: {
        postId: string;
        replyId: string;
        isOpenModal: boolean;
        isLoading?: boolean;
        isError?: boolean;
    }) => void;
    className?: string;
    relatedComments?: { data: MessageType[] }[];
}

const ReplyComment = ({
    comment,
    reply,
    activeFormReply,
    markAsRead,
    socialProfile,
    user,
    variant,
    setReplyToAdd,
    setActiveFormReply,
    setDeleteReplyState,
    className,
    relatedComments
}: ReplyCommentProps) => {
    const handleReplyToAdd = () => {
        setReplyToAdd({ commentId: comment.id, reply });
    };

    const handleActiveFormReply = (status: 'open' | 'close') => {
        if (status === 'open') {
            setActiveFormReply({
                currentComment: reply,
                currentCommentId: reply.id,
                parent: comment
            });
        }
    };

    const handleDeleteReply = () => {
        setDeleteReplyState({
            postId: reply.media_id,
            replyId: reply.id,
            isOpenModal: true
        });
    };

    return (
        <Comment
            key={comment.id}
            activeFormReply={activeFormReply}
            className={className}
            comment={reply}
            // @ts-expect-error TODO: Refactor Comment component to use TS
            markAsRead={markAsRead}
            socialProfile={socialProfile}
            user={user}
            variant={variant}
            handleReplyToAdd={handleReplyToAdd}
            // @ts-expect-error TODO: Refactor Comment component to use TS
            handleActiveFormReply={handleActiveFormReply}
            deleteComment={handleDeleteReply}
            relatedComments={relatedComments}
        />
    );
};

export default ReplyComment;
